export default {
  xs: `400px`,
  sm: `550px`,
  md: `750px`,
  lg: `1023px`,
  xl: `1200px`,
  xxl: `1600px`,
}
